import CommonUtils from "../../../../utils/Common_Utils";
import { DomainScore } from "../../skill_score/interface/ScoreResponse_Interface";
import "../styles/OverallResultCardStyles.css";
import CalenderIcon from "../../../../assets/images/inventory_dashboard/calender.png";
import ClockIcon from "../../../../assets/images/inventory_dashboard/clock.png";
import ZeroBulb from "../../../inventory_dashboard/assets/bulb_images/bulb0.png";
import LowRedBulb from "../../../inventory_dashboard/assets/bulb_images/lowred.png";
import RedBulb from "../../../inventory_dashboard/assets/bulb_images/RedBulb.png";
import GreenBulb from "../../../inventory_dashboard/assets/bulb_images/GreenBulb.png";
import YellowBulb from "../../../inventory_dashboard/assets/bulb_images/YellowBulb.png";
import LowYellowBulb from "../../../inventory_dashboard/assets/bulb_images/LowYellowBulb.png";
import NoImage from "../../../../assets/images/inventory_dashboard/noassessmentexplain.png";
import LowGreenBulb from "../../../inventory_dashboard/assets/bulb_images/LowGreenBulb.png";
import { IndustryScoreColors } from "../interfaces/IndustryScoreColors";
interface ProfessionalPageProps {
  data: DomainScore[];
  date: String;
  assessment_title: string;
  overall_score: number;
  onViewResultClick: (domain: DomainScore) => void;
  duration: number;
  showAnswers?: boolean; // added this key for show and hide the view Result Button
  curriculum?: string;
}

const OverallResultCardPage: React.FC<ProfessionalPageProps> = ({
  data,
  date,
  assessment_title,
  overall_score,
  onViewResultClick,
  duration,
  showAnswers,
  curriculum,
}) => {
  const getScroeBoardResult = (
    score: number,
  ): {
    backgroundColor: string;
    textColor: string;
    bulbImage: string;
    text: string;
  } => {
    let backgroundColor: string;
    let textColor: string;
    let bulbImage: string;
    let text: string;

    if (score <= 0) {
      backgroundColor = "#FFDADA";
      textColor = "#DF3030";
      bulbImage = ZeroBulb;
      text =
        "Let’s get started! 🚀\nBegin with the first topic and take it one step at a time.";
    } else if (score >= 1 && score <= 10) {
      backgroundColor = "#FFDADA";
      textColor = "#DF3030";
      bulbImage = LowRedBulb;
      text =
        "Let’s refocus! 📘✨ \nSpend a little more time reviewing the basics.";
    } else if (score >= 11 && score <= 20) {
      backgroundColor = "#FFDADA";
      textColor = "#DF3030";
      bulbImage = LowRedBulb;
      text =
        "Keep trying! 💪📚 \nIdentify where you’re stuck and revise those topics.";
    } else if (score >= 21 && score <= 30) {
      backgroundColor = "#FFDADA";
      textColor = "#DF3030";
      bulbImage = RedBulb;
      text =
        "Stay consistent! 🔍✨ \nPractice regularly and try solving a few sample questions.";
    } else if (score >= 31 && score <= 40) {
      backgroundColor = "#FFDADA";
      textColor = "#DF3030";
      bulbImage = RedBulb;
      text =
        "Good effort, but needs more focus! 🎯📘 \nRevise the key concepts daily.";
    } else if (score >= 41 && score <= 50) {
      backgroundColor = "#FFDADA";
      textColor = "#DF3030";
      bulbImage = RedBulb;
      text =
        "Nice attempt! 📈 \nRevisit difficult areas—you’re closer than you think!";
    } else if (score >= 51 && score <= 60) {
      backgroundColor = "#F7E9AF";
      textColor = "#F7921B";
      bulbImage = LowYellowBulb;
      text =
        "Great job! 🚀✨\nKeep the momentum going by practicing a bit more each day.";
    } else if (score >= 61 && score <= 70) {
      backgroundColor = "#F7E9AF";
      textColor = "#F7921B";
      bulbImage = LowYellowBulb;
      text =
        "Fantastic progress! 🔥✨\nA little more consistency will take you even higher!";
    } else if (score >= 71 && score < 80) {
      backgroundColor = "#F7E9AF";
      textColor = "#F7921B";
      bulbImage = LowYellowBulb;
      text =
        "You’re doing great! 🎉 \nBrush up on weak areas to boost your score further.";
    } else if (score >= 80 && score <= 90) {
      backgroundColor = "#CBFAE9";
      textColor = "#24C782";
      bulbImage = LowGreenBulb;
      text = "Amazing work! 🌟📘\nKeep up the focus and you’ll reach the top!";
    } else if (score >= 91 && score <= 99) {
      backgroundColor = "#CBFAE9";
      textColor = "#24C782";
      bulbImage = LowGreenBulb;
      text = "Outstanding! 🏆✨\nYour hard work shows—excellent performance!";
    } else {
      text = "Congratulations! You did it 🎉 Keep shining!";
      backgroundColor = "#CBFAE9";
      textColor = "#24C782";
      bulbImage = GreenBulb;
    }

    return {
      backgroundColor,
      textColor,
      bulbImage,
      text,
    };
  };

  return (
    <>
      <div className="industryresults-exam-card">
        <div className="industryresults-exam-info">
          <h3 className="industryresults-exam-title">{assessment_title}</h3>
          <div className="industryresults-exam-meta">
            <div className="industryresults-exam-date">
              <img
                className="industryresults-exam-img"
                src={CalenderIcon}
              ></img>
              <p className="industryresults-exam-text">{date?.split(",")[0]}</p>
            </div>
            {duration && (
              <div className="industryresults-exam-duration">
                <img className="industryresults-exam-img" src={ClockIcon}></img>
                <p className="industryresults-exam-text">{duration}</p>
              </div>
            )}
          </div>
        </div>
        <div className="industryresults-exam-feedback">
          <p
            dangerouslySetInnerHTML={{
              __html: getScroeBoardResult(overall_score).text.replace(
                /\n/g,
                "<br />",
              ),
            }}
          />

          <div
            className="industryresults-exam-score"
            style={{
              backgroundColor:
                getScroeBoardResult(overall_score).backgroundColor,
            }}
          >
            <p
              style={{
                color: getScroeBoardResult(overall_score).textColor,
              }}
            >
              {overall_score}%
            </p>
            <img
              src={getScroeBoardResult(overall_score).bulbImage}
              className="industryresults-score-bulb"
            ></img>
          </div>
        </div>
      </div>
      {data && data.length > 0 ? (
        <div className="industryresults-grid-container">
          {data.map((record, index) => (
            <div
              key={index}
              className="industryresults-grid-item"
              style={{
                backgroundColor: CommonUtils.getIndustryScoreColors(
                  record.domain_score,
                ).backgroundColor,
                display: "flex",
                flexDirection: "column",
                justifyContent: "space-between",
                padding: "20px",
              }}
            >
              {/* Top content */}
              <div>
                <div className="industryresults-score-container">
                  <p className="industryresults-percent-title">
                    {record.domain_name}
                  </p>
                </div>

                <div style={{ padding: "10px 30px" }}>
                  <p
                    className="industryresults-percent-score"
                    style={{
                      color: CommonUtils.getIndustryScoreColors(
                        record.domain_score,
                      ).percentColor,
                    }}
                  >
                    {record.domain_score} %
                  </p>
                </div>
                {showAnswers === true && curriculum === "Yes" && (
                  <div style={{ textAlign: "center", marginTop: "20px" }}>
                    <button
                      onClick={() => {
                        onViewResultClick(record);
                      }}
                      style={{
                        padding: "10px 20px",
                        backgroundColor: "#FFC85D",
                        color: "#1A1F24",

                        border: "none",
                        borderRadius: "8px",
                        cursor: "pointer",
                        fontWeight: "600",
                      }}
                    >
                      View Result
                    </button>
                  </div>
                )}
                {curriculum === "No" && (
                  <div style={{ textAlign: "center", marginTop: "20px" }}>
                    <button
                      onClick={() => {
                        onViewResultClick(record);
                      }}
                      style={{
                        padding: "10px 20px",
                        backgroundColor: "#FFC85D",
                        color: "#1A1F24",

                        border: "none",
                        borderRadius: "8px",
                        cursor: "pointer",
                        fontWeight: "600",
                      }}
                    >
                      View Result
                    </button>
                  </div>
                )}
              </div>
            </div>
          ))}
        </div>
      ) : (
        <div
          style={{
            fontSize: "18px",
            fontWeight: "500",
            color: "#999",
            display: "flex",
            flexDirection: "column", // stack vertically
            justifyContent: "center",
            alignItems: "center",
            width: "100%",
            textAlign: "center",
            paddingTop: "25px",
          }}
        >
          <img
            src={NoImage}
            style={{
              height: "240px",
              width: "340px",
              marginBottom: "10px",
            }}
            alt="No Data"
          />
          <span
            style={{ fontFamily: "Mazzard", color: "#272727", fontWeight: 600 }}
          >
            No assessment scores to show
          </span>
        </div>
      )}
    </>
  );
};

export default OverallResultCardPage;
